import React from 'react';
import './EndGameModal.css';

interface EndGameModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const EndGameModal: React.FC<EndGameModalProps> = ({ onConfirm, onCancel }) => {
  return (
    <div className="alien2048-endgame-overlay" onClick={onCancel}>
      <div className="alien2048-endgame-content" onClick={e => e.stopPropagation()}>
        <h2>End Game Early?</h2>
        <p>View Leaderboard after ending game.</p>

        <div className="alien2048-endgame-buttons">
          <button className="alien2048-endgame-button cancel-button" onClick={onCancel}>
            Cancel
          </button>
          <button className="alien2048-endgame-button confirm-button" onClick={onConfirm}>
            End Game
          </button>
        </div>
      </div>
    </div>
  );
};

export default EndGameModal;
